<input #fileInput (click)="fileInput.value = null" (change)="uploadLocalFile($event)" accept="video/mp4"
[className]="chunksClass" id="uploadMp4" type="file" name="preview-file-upload">